import React, { useEffect, type ReactNode } from 'react';
import { observer } from 'mobx-react';
import { ThemeProvider } from '@emotion/react';
import { useTheme } from 'hooks/use-theme';

const ThemeProviderWrapper: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const { appTheme } = useTheme();

  // The dark design tokens only apply under [data-theme='dark'].
  useEffect(() => {
    document.documentElement.dataset.theme = appTheme.mode;
  }, [appTheme.mode]);

  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};

export default observer(ThemeProviderWrapper);
